import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Read all params sent by the backend redirect
  const plan    = searchParams.get('plan')    || '—';
  const amount  = searchParams.get('amount');
  const expiry  = searchParams.get('expiry');
  const txn     = searchParams.get('txn')     || '—';
  const gateway = searchParams.get('gateway') || '—';

  const formattedExpiry = expiry
    ? new Date(expiry).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })
    : null;

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {/* Success icon */}
        <div style={styles.iconCircle}>
          <svg viewBox="0 0 24 24" fill="none" stroke="#1a7f40" strokeWidth="2.5"
            strokeLinecap="round" strokeLinejoin="round" width="38" height="38">
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </div>

        <h1 style={styles.title}>Payment Successful!</h1>
        <p style={styles.subtitle}>
          Your subscription has been activated. Details are below.
        </p>

        {/* Transaction details */}
        <div style={styles.details}>
          <DetailRow label="Plan" value={plan} />
          {amount && <DetailRow label="Amount" value={`₹ ${amount}`} />}
          {formattedExpiry && <DetailRow label="Valid Until" value={formattedExpiry} />}
          <DetailRow label="Transaction ID" value={txn} small />
          <DetailRow label="Gateway" value={gateway} last />
        </div>

        <button style={styles.btn} onClick={() => navigate('/')}>
          Back to Home
        </button>
      </div>
    </div>
  );
};

const DetailRow = ({ label, value, small, last }) => (
  <div style={{ ...styles.row, ...(last ? { borderBottom: 'none', marginBottom: 0, paddingBottom: 0 } : {}) }}>
    <strong style={styles.rowLabel}>{label}</strong>
    <span style={{ ...styles.rowValue, ...(small ? { fontSize: '0.82rem', wordBreak: 'break-all', textAlign: 'right', maxWidth: '60%' } : {}) }}>
      {value}
    </span>
  </div>
);

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    background: 'radial-gradient(circle at top right, #c8f0d8 0%, rgba(200,240,216,0) 50%), #f4fff8',
    fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif',
    color: '#12291a',
  },
  card: {
    background: '#fff',
    border: '1px solid #c3e6ce',
    borderRadius: '18px',
    boxShadow: '0 12px 40px rgba(15,60,30,0.10)',
    padding: '36px 28px',
    maxWidth: '440px',
    width: '100%',
    textAlign: 'center',
  },
  iconCircle: {
    width: '72px',
    height: '72px',
    background: '#eafaf0',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 20px',
  },
  title: {
    fontSize: '1.5rem',
    marginBottom: '8px',
    color: '#1a7f40',
    fontWeight: '700',
  },
  subtitle: {
    fontSize: '0.97rem',
    color: '#4a7c5e',
    marginBottom: '24px',
    lineHeight: '1.55',
  },
  details: {
    background: '#eafaf0',
    border: '1px solid #c3e6ce',
    borderRadius: '12px',
    padding: '16px',
    textAlign: 'left',
    fontSize: '0.95rem',
    lineHeight: '1.8',
  },
  row: {
    borderBottom: '1px solid #c3e6ce',
    paddingBottom: '8px',
    marginBottom: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  rowLabel: { color: '#12291a' },
  rowValue: { color: '#4a7c5e' },
  btn: {
    display: 'block',
    marginTop: '24px',
    padding: '13px',
    background: '#1a7f40',
    color: '#fff',
    border: 'none',
    borderRadius: '12px',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    width: '100%',
  },
};

export default PaymentSuccess;